<template>
  <div id="app">
    <router-view style="min-height:93vh"></router-view>
    <tab-bar></tab-bar>
  </div>
</template>

<script>
import TabBar from './components/TabBar.vue'
export default {
  components: { TabBar },
  name: 'App',
  data(){
    return{}
  },
  mounted(){
        // 初始化获取浏览器窗口大小
        this.screenWidth = document.body.clientWidth;
        // 根据浏览器窗口大小判断是否显示页面内的部分内容
        if(this.screenWidth<1200){
            this.screenState=false;
        }else{
            this.screenState=true;
        }
  }
}
</script>

<style>
*{
  margin:0;
  padding: 0;
}
#app{
  height: 100vh;
}

</style>



// WEBPACK FOOTER //
// src/App.vue